import { render, staticRenderFns } from "./sharing_expiration.vue?vue&type=template&id=03bc6a0a&"
import script from "./sharing_expiration.vue?vue&type=script&lang=js&"
export * from "./sharing_expiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports